import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';

const Container = styled.div`
    /* border: 1px solid red; */
    width: 100%;
    height: auto;
    flex-grow: 4;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.2rem 0;
`

const Title = styled.div`
    font-size: 0.8rem;
    font-weight: normal !important;
    @media (min-width: 600px) {
        font-size: 1rem;
    }
`

const Subtitle = styled.div`
    font-size: 0.8rem !important;
    font-weight: normal !important;
    margin-bottom: 0.2rem;
`

const WeekHeader = props => {
    return (
        <Container>
            <Subtitle>{format(props.date, 'E')}</Subtitle>
            <Title>{format(props.date, 'd')}</Title>
        </Container>
    )
}

export default WeekHeader